import React, { useState } from 'react';
import classNames from 'classnames';

import { useTranslate } from '../../../../i18n/useTranslationModules';
import CustomCheckbox from '../../../general-ui/checkbox/custom-checkbox';
import { IOptInStatus } from '../../../../connection/registration';
import { MarketingOptInTypes, OptInStatus } from '../../../../types/working-model';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';



export function OptInCheckBoxes({
	setOptInStatus,
	template,
	soldOut}:
	{
		setOptInStatus?: React.Dispatch<React.SetStateAction<IOptInStatus>>;
		soldOut: boolean;
		template: string;
	}): JSX.Element {
	const { t } = useTranslate('homepage');

	const eventBundle = useTypedSelector(state => state.LiveEventReducer.eventBundle);
	const marketingOptInType = eventBundle?.registration_settings?.marketing_email_options;
	const optInFeatureFlag = useTypedSelector(state =>state.FeatureFlagsReducer.featureFlags["streams.gdpr_marketing_email"]);

	const [singleOptIn, setSingleOptIn] = useState(false);
	const [doubleOptIn, setDoubleOptIn] = useState(false);


	const handleSingleOptIn = (_isChecked: boolean) => {
		if (setOptInStatus) {
			const status = _isChecked ? OptInStatus.optedIn : OptInStatus.optedOut;
			setOptInStatus(prev => ({ ...prev, singleOptIn: status }));
			setSingleOptIn(_isChecked);
		}
	};

	// PART OF THE NEXT TICKET FOR DOUBLE OPT-IN
	// const handleDoubleOptIn = (_isChecked: boolean) => {
	// 	if (setOptInStatus) {
	// 		const status = _isChecked ? OptInStatus.optedIn : OptInStatus.optedOut;
	// 		setOptInStatus(prev => ({ ...prev, doubleOptIn: status }));
	// 		setDoubleOptIn(_isChecked);
	// 	}
	// };

	return (
		<>
			{optInFeatureFlag &&  marketingOptInType === MarketingOptInTypes.singleOptIn ?
				<div className={classNames('evt-field-wrapper', template)}>
					<CustomCheckbox
						key={'single_opt_in'}
						label={t(`registration.registration_fields.single_opt_in`)}
						name={'single_opt_in'}
						disabled={soldOut}
						required={false}
						onChange={handleSingleOptIn}
						defaultValue={false}
						checked={singleOptIn}
						useMarkdown
					/>
				</div>
				:
				<></>
			}

			{/* WELCOME to the double optin field. Once we get started with this ticket, all 
					you need to do us uncomment the below code to enable the double opt-in checkbox */}
			{/* 
				{optInFeatureFlag &&  marketingOptInType === MarketingOptInTypes.doubleOptIn ?
				<div className={classNames('evt-field-wrapper', template)}>
					<CustomCheckbox
						key={'double_opt_in'}
						label={t(`registration.registration_fields.double_opt_in`)}
						name={'double_opt_in'}
						disabled={soldOut}
						required={false}
						onChange={handleDoubleOptIn(prev => !prev)}
						defaultValue={false}
						checked={doubleOptIn}
						useMarkdown
					/> 
				</div>:
				<></>
			}
			*/}
		</>
	);
}
